import { render, staticRenderFns } from "./market-list.vue?vue&type=template&id=c8b158b0&scoped=true&"
import script from "./market-list.vue?vue&type=script&lang=ts&"
export * from "./market-list.vue?vue&type=script&lang=ts&"
import style0 from "./market-list.vue?vue&type=style&index=0&id=c8b158b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b158b0",
  null
  
)

export default component.exports